import React from 'react';
import {FaAngleDown, FaAngleUp} from 'react-icons/fa';

export default class UserSection extends React.Component {
    static defaultProps = {
        isOpen: true
    }

    constructor () {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            is_open: true
        }
    }

    componentDidMount () {
        this.setState({
            is_open: this.props.isOpen
        });
    }

    handleClick (e) {
        e.preventDefault();
        this.setState({
            is_open: !this.state.is_open
        });
    }

    render () {
        return (<section className="user-section">
            <header><a href="#expand" onClick={this.handleClick}>{this.props.header} {this.state.is_open ? <FaAngleUp /> : <FaAngleDown />}</a></header>
            <div className="user-section-body" style={{display: this.state.is_open ? 'block': 'none'}}>{this.props.children}</div>
        </section>)
    }
}
